
import { X, Settings } from "lucide-react";
import { Button } from "@/components/Button";
import { useCookieConsent } from "@/hooks/useCookieConsent";
import { Link } from "react-router-dom";

export const CookieBanner = () => {
  const { showBanner, acceptAll, rejectAll, openSettings, closeBanner } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background/95 backdrop-blur-lg border-t border-white/10">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-start justify-between mb-2">
              <h3 className="text-lg font-semibold text-white">Cookie Preferences</h3>
              <button
                onClick={closeBanner}
                className="text-white/70 hover:text-white transition-colors lg:hidden"
                aria-label="Close banner"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <p className="text-sm text-white/80 mb-4 lg:mb-0">
              We use cookies to enhance your experience, analyze site performance, and assist with our marketing efforts. 
              We respect your privacy and comply with CCPA regulations. You can customize your preferences or accept all cookies.{" "}
              <Link to="/privacy-policy" className="text-primary hover:text-primary/80 underline">
                Learn more in our Privacy Policy
              </Link>
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
            <Button
              variant="outline"
              size="sm"
              onClick={rejectAll}
              className="border-white/20 text-white hover:bg-white/10"
            >
              Reject All
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={openSettings}
              className="border-white/20 text-white hover:bg-white/10"
            >
              <Settings className="h-4 w-4 mr-2" />
              Customize
            </Button>
            <Button
              variant="primary"
              size="sm"
              onClick={acceptAll}
            >
              Accept All
            </Button>
          </div>
          
          <button
            onClick={closeBanner}
            className="hidden lg:block text-white/70 hover:text-white transition-colors ml-4"
            aria-label="Close banner"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};
